<div class="create-post-container" [ngClass]="getContainerClass()">
  <div class="post-card">
    <!-- Header -->
    <div class="post-header">
      <h3 class="header-title">
        <span class="community-name">AumYe Community</span>
        <span class="separator">|</span>
        <span class="action-text">Create post</span>
      </h3>
      <button class="close-btn" (click)="closeDialog()" aria-label="Close">
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>

    <!-- Content -->
    <div class="post-content">
      <!-- User Info -->
      <div class="user-info-section">
        <div class="user-avatar">
          <img
            [src]="loggedIsUsernameProfile"
            [alt]="loggedIsUsername + ' avatar'"
          />
        </div>
        <div class="user-details">
          <h4 class="username">{{ loggedIsUsername | titlecase }}</h4>
          <div class="post-validity" *ngIf="selectedDate">
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
              <line x1="16" y1="2" x2="16" y2="6"></line>
              <line x1="8" y1="2" x2="8" y2="6"></line>
              <line x1="3" y1="10" x2="21" y2="10"></line>
            </svg>
            <span
              >Valid until:
              <strong>{{ selectedDate | date : "MMM dd, yyyy" }}</strong></span
            >
          </div>
        </div>
      </div>

      <!-- Text Input -->
      <div class="input-section">
        <div class="text-input-container" [class.with-poll]="isPollShared">
          <textarea
            #postTextarea
            [(ngModel)]="postText"
            (input)="onTextInput($event)"
            (keydown)="onKeyDown($event)"
            placeholder="What's on your mind?"
            class="post-textarea"
            [class.with-suggestions]="showUserList"
            rows="3"
            maxlength="2000"
          ></textarea>

          <div class="character-count" *ngIf="postText?.length > 1800">
            {{ postText?.length || 0 }}/2000
          </div>

          <div class="shared-poll-indicator" *ngIf="isPollShared">
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <path
                d="M9 11H5a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2z"
              ></path>
              <path
                d="M19 4H15a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z"
              ></path>
            </svg>
            <span>{{ pollTitle }}</span>
          </div>
        </div>

        <!-- User Suggestions -->
        <div class="user-suggestions" *ngIf="showUserList" #userSuggestions>
          <div
            class="suggestion-item"
            *ngFor="let user of filteredUserOrgList; let i = index"
            [class.active]="i === selectedIndex"
            (click)="selectUser(user)"
          >
            <div class="suggestion-avatar">
              <img
                [src]="user.profilePicture || defaultUserImage"
                [alt]="user.firstname + ' ' + user.lastname"
              />
            </div>
            <div class="suggestion-info">
              <span class="suggestion-name"
                >{{ user.firstname }} {{ user.lastname }}</span
              >
            </div>
          </div>
        </div>
      </div>

      <!-- Image Preview -->
      <div
        class="image-preview"
        *ngIf="uploadedAttachment"
        [class.mobile]="screenInfo === ScreenType.Mobile"
      >
        <div class="image-container">
          <img [src]="uploadedAttachment" alt="Uploaded image preview" />
          <div class="image-overlay">
            <button
              class="remove-image-btn"
              (click)="removeImage()"
              aria-label="Remove image"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
              >
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="15" y1="9" x2="9" y2="15"></line>
                <line x1="9" y1="9" x2="15" y2="15"></line>
              </svg>
            </button>
          </div>
        </div>
      </div>

      <!-- Actions -->
      <div class="post-actions">
        <div class="action-buttons">
          <!-- Date Picker -->
          <button
            class="action-btn"
            (click)="toggleDatePicker()"
            [class.active]="showDatePicker"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
              <line x1="16" y1="2" x2="16" y2="6"></line>
              <line x1="8" y1="2" x2="8" y2="6"></line>
              <line x1="3" y1="10" x2="21" y2="10"></line>
            </svg>
            <span>Set Validity</span>
          </button>

          <!-- Image Upload -->
          <button class="action-btn" (click)="selectFile()">
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
              <circle cx="8.5" cy="8.5" r="1.5"></circle>
              <polyline points="21,15 16,10 5,21"></polyline>
            </svg>
            <span>Add Photo</span>
          </button>

          <!-- File Input -->
          <input
            type="file"
            #fileInput
            class="hidden-file-input"
            accept="image/*"
            (change)="handleFileChange($event)"
          />
        </div>

        <!-- Custom Date Picker -->
        <div class="date-picker-container" *ngIf="showDatePicker" #datePicker>
          <div class="date-picker">
            <div class="date-picker-header">
              <h4>Set Post Validity</h4>
              <button class="close-date-picker" (click)="closeDatePicker()">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>
            </div>
            <div class="date-picker-body">
              <input
                type="date"
                [(ngModel)]="selectedDateString"
                [min]="minDateString"
                [max]="maxDateString"
                class="date-input"
              />
              <div class="quick-options">
                <button
                  *ngFor="let option of quickDateOptions"
                  class="quick-option"
                  (click)="selectQuickDate(option.days)"
                >
                  {{ option.label }}
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Post Button -->
        <div class="post-button-container">
          <button
            class="post-btn"
            [disabled]="isPostDisabled()"
            (click)="createPost()"
            [class.loading]="isPosting"
          >
            <span *ngIf="!isPosting">Post</span>
            <mat-spinner [diameter]="25" *ngIf="isPosting"></mat-spinner>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
